(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function norm(s) { return (s || '').toString().trim().toUpperCase().replace(/\s+/g, ''); }
    function parseCodes(raw) { return (raw || '').split(/[\s,;]+/).map(norm).filter(Boolean); }

    function initGate(el) {
      if (el.dataset.mtBound) return;
      el.dataset.mtBound = '1';
      var input = el.querySelector('.mt-zipgate__input');
      var btn = el.querySelector('.mt-zipgate__btn');
      var result = el.querySelector('.mt-zipgate__result');
      if (!input || !btn || !result) return;
      var id = el.getAttribute('data-gate-id');
      var reveal = document.querySelector('.mt-zipgate-reveal[data-gate-id="' + id + '"]');
      var codes = parseCodes(el.getAttribute('data-codes'));
      var url = el.getAttribute('data-url');
      var msgOk = el.getAttribute('data-msg-success') || 'Tu código postal se encuentra dentro de la cobertura logística de Mundo Tool. Puedes continuar tu registro al programa mayorista.';
      var msgErr = el.getAttribute('data-msg-error') || 'Por el momento nuestro programa comercial de mayoreo está disponible únicamente en zonas con cobertura logística de Mundo Tool. Déjanos tus datos y te contactaremos cuando ampliemos la cobertura.';
      var delay = parseInt(el.getAttribute('data-delay'), 10);
      if (isNaN(delay)) delay = 1500;
      var remote = null;

      function loadRemote() {
        if (!url) return Promise.resolve([]);
        if (remote) return Promise.resolve(remote);
        return fetch(url).then(function (r) { return r.text(); }).then(function (t) {
          remote = parseCodes(t.replace(/[^0-9A-Za-z]+/g, ' '));
          return remote;
        }).catch(function () { return []; });
      }

      function setResult(cls, msg, cp) {
        result.className = 'mt-zipgate__result ' + cls;
        result.textContent = msg.replace(/\{cp\}/g, cp);
      }

      function check() {
        var cp = norm(input.value);
        if (!cp) { input.focus(); return; }
        el.classList.add('is-loading');
        btn.disabled = true;
        loadRemote().then(function (extra) {
          var all = codes.concat(extra || []);
          var ok = all.indexOf(cp) > -1;
          el.classList.remove('is-loading');
          if (ok) {
            btn.disabled = true;
            setResult('is-success', msgOk, cp);
            setTimeout(function () {
              el.classList.add('is-done');
              if (reveal) reveal.hidden = false;
              setTimeout(function () { el.style.display = 'none'; }, 480);
            }, delay);
          } else {
            btn.disabled = false;
            setResult('is-error', msgErr, cp);
            if (reveal) reveal.hidden = true;
          }
        });
      }

      btn.addEventListener('click', check);
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); check(); }
      });
    }

    function initAll(root) {
      (root || document).querySelectorAll('.mt-zipgate').forEach(initGate);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
